/**
 * Ответ советника — в вид окна: короткий текстом, сценарий по частям.
 *
 * Один на окно «Спроси SKOKA» и первый разбор в онбординге: два разных
 * вида одного ответа человек читал бы как ответы двух разных приложений.
 */
import type { AdvisorAnswer } from '@skoka/core';
import type { ChatAnswer } from './chat-view.js';

const key = (s: string) => s.trim().replace(/\.$/, '').toLowerCase();

export function chatAnswerOf(a: AdvisorAnswer): { text: string } | { answer: ChatAnswer } {
  // Тон без расчёта ответа сценарием не делает: «до зарплаты ≈ 833 ₽ в
  // день» — одна фраза, и значок над ней ничего не добавит.
  const structured = Boolean(a.conditions?.length || a.figures?.length || a.details?.length || a.action);
  if (!structured) return { text: [a.headline, a.basis].filter(Boolean).join(' ') };
  const shown = new Set([...(a.details ?? []), a.warning ?? ''].map(key));
  return {
    answer: {
      verdict: a.headline,
      tone: a.tone ?? 'info',
      ...(a.conditions?.length ? { conditions: a.conditions } : {}),
      ...(a.conditionsNote ? { conditionsNote: a.conditionsNote } : {}),
      ...(a.figures?.length ? { figures: a.figures } : {}),
      ...(a.warning ? { warning: a.warning } : {}),
      ...(a.action ? { step: a.action } : {}),
      details: [
        ...(a.basis ? [a.basis] : []),
        ...(a.details ?? []),
        // Ограничения расчёта не теряются: то, чего модель не пересказала, —
        // в «Как посчитано».
        ...a.limits.filter((l) => !shown.has(key(l))),
        ...a.alternatives.map((v) => (v.effect ? `${v.label}: ${v.effect}` : v.label)),
        ...(a.withoutModel ? ['Это расчёт без разбора ИИ: числа посчитаны приложением, не хватает объяснения словами.'] : []),
      ],
    },
  };
}
